// src/components/Timer/Timer.jsx
import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { toast } from 'react-toastify';
import '../../styles/theme-components.css';

const Timer = ({ initialTime = 600, onTimeUp, isStopped = false, storageKey }) => {
  const [timeRemaining, setTimeRemaining] = useState(() => {
    const savedTime = localStorage.getItem(`${storageKey}_time`);
    return savedTime ? parseInt(savedTime, 10) : initialTime;
  });
  const [isWarning, setIsWarning] = useState(false);
  const [isCritical, setIsCritical] = useState(false);

  useEffect(() => {
    if (isStopped) return;

    const interval = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev > 0) {
          if (prev <= 120 && prev > 60) setIsWarning(true);
          if (prev <= 60) {
            setIsCritical(true);
            setIsWarning(false);
          }
          localStorage.setItem(`${storageKey}_time`, prev - 1); // ذخیره زمان باقی‌مانده
          return prev - 1;
        } else {
          clearInterval(interval);
          localStorage.removeItem(`${storageKey}_time`); // پاک کردن زمان بعد از اتمام
          toast.warn('زمان شما به پایان رسید! پاسخ‌ها به‌صورت خودکار ارسال شدند.', {
            position: 'top-right',
            autoClose: 3000,
          });
          onTimeUp();
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onTimeUp, isStopped, storageKey]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <div className="flex justify-center items-center mb-8">
      <div
        className={`flex items-center gap-3 px-6 py-3 rounded-2xl backdrop-blur-md
          border transition-all duration-300 shadow-lg
          ${
            isCritical
              ? 'bg-[rgb(var(--timer-critical-bg))] border-[rgb(var(--timer-critical-border))] timer-critical'
              : isWarning
              ? 'bg-[rgb(var(--timer-warning-bg))] border-[rgb(var(--timer-warning-border))]'
              : 'bg-[rgb(var(--timer-bg))] border-[rgb(var(--timer-border))]'
          }`}
        aria-live="polite"
      >
        <Clock
          className={`w-6 h-6 ${
            isCritical
              ? 'text-[rgb(var(--timer-critical-text))]'
              : isWarning
              ? 'text-[rgb(var(--timer-warning-text))]'
              : 'text-[rgb(var(--timer-text))]'
          }`}
        />
        <div className="flex flex-col items-start">
          <span
            className={`text-sm ${
              isCritical
                ? 'text-[rgb(var(--timer-critical-text))]'
                : isWarning
                ? 'text-[rgb(var(--timer-warning-text))]'
                : 'text-[rgb(var(--timer-text))]'
            }`}
          >
            زمان باقی‌مانده
          </span>
          <span
            className={`text-xl font-mono font-bold ${
              isCritical
                ? 'text-[rgb(var(--timer-critical-text))]'
                : isWarning
                ? 'text-[rgb(var(--timer-warning-text))]'
                : 'text-[rgb(var(--timer-text))]'
            }`}
          >
            {formatTime(timeRemaining)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Timer;